<template>
  <div>
    <VaDropdown v-model="isShown" class="my-dropdown" :offset="[9, 0]" stick-to-edges>
      <template #anchor>
        <VaButton preset="secondary" color="textInverted">
          <span class="my-dropdown__anchor min-w-max">
            <slot />
            <VaIcon name="language" class="mx-2" size="2rem" />
          </span>
        </VaButton>
      </template>

      <VaDropdownContent class="my-dropdown__content md:w-60 px-0 py-4 w-full" :style="{ '--hover-color': hoverColor }">
        <VaList>
          <VaListItem
            v-for="option in options"
            :key="option.locale"
            class="menu-item px-4 text-base cursor-pointer h-8"
            :class="{ 'my-item-bg': option.locale === locale }"
            @click="changeLanguage(option.locale)"
          >
            <span>{{ option.label }}</span>
            <span v-if="locale === option.locale" class="px-2">✔</span>
          </VaListItem>
        </VaList>
      </VaDropdownContent>
    </VaDropdown>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { useColors } from 'vuestic-ui'
import {
  NATIVE_LOCALE_LABELS,
  SUPPORTED_LOCALES,
  applyDocumentDirection,
  normalizeAppLocale,
  pathForLocale,
  type AppLocale,
} from '../../../../utils/locale'

const { colors, setHSLAColor } = useColors()
const hoverColor = computed(() => setHSLAColor(colors.focus, { a: 0.1 }))

const { locale } = useI18n()
const route = useRoute()
const router = useRouter()

const options = SUPPORTED_LOCALES.map((code) => ({
  locale: code,
  label: NATIVE_LOCALE_LABELS[code],
}))

const isShown = ref(false)

const changeLanguage = (lang: string) => {
  const target = normalizeAppLocale(lang) as AppLocale
  const nextPath = pathForLocale(route.path, target)

  locale.value = target
  applyDocumentDirection(target)
  router.push({
    path: nextPath,
    query: route.query,
    hash: route.hash,
  })
  isShown.value = false
}
</script>

<style scoped lang="scss">
.my-dropdown {
  cursor: pointer;

  &__anchor {
    display: inline-block;
  }

  &__content {
    background: #064e8a !important;
    border-radius: 8px;
    .menu-item {
      transition: background 0.15s ease;
      color: #fff;
      &:hover {
        background-color: var(--hover-color);
      }
    }
  }
}
</style>
